import {
  provideKeycloak,
  withAutoRefreshToken,
  AutoRefreshTokenService,
  UserActivityService,
} from 'keycloak-angular';

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: 'https://keycloak.tetralab.hr/',
      realm: 'legal',
      clientId: 'legal',
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri:
        window.location.origin + '/silent-check-sso.html',
      redirectUri: window.location.origin + '/',
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'none',
        sessionTimeout: 24 * 60 * 60 * 1000, //24 hours, we don't want to logout the user
      }),
    ],
    providers: [AutoRefreshTokenService, UserActivityService],
  });
